import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// project import
import config from 'config';

// types
import { GuardProps } from 'types/auth';
import useAuth from 'hooks/useAuth';

// ==============================|| GUEST GUARD ||============================== //

const GuestGuard = ({ children }: GuardProps) => {
  const { isLoggedIn, isInitialized } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoggedIn && isInitialized) {
      navigate(config.defaultPath, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInitialized, isLoggedIn]);

  return children;
};

export default GuestGuard;
